import { render, staticRenderFns } from "./Answer.vue?vue&type=template&id=78aa02e2"
import script from "./Answer.vue?vue&type=script&lang=js"
export * from "./Answer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports